import React from "react";
import ReactDOM from "react-dom/client";


import App from "./App";
import ThemeProvider from "./theme";
import { Provider } from "react-redux";
import store from "redux/store/Store";
import { ToastContainer } from "react-toastify";
import "styles/utility.css";
import "styles/App.css";

import "react-toastify/dist/ReactToastify.css";
import { GoogleOAuthProvider } from "@react-oauth/google";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <ThemeProvider>
      <GoogleOAuthProvider clientId='362515734491-11giabslh1n0alpke92offp8oupb2du8.apps.googleusercontent.com'>
        <App />
      </GoogleOAuthProvider>
      <ToastContainer theme="dark" style={{ color: '#fff', fontWeight: 600 }} />
    </ThemeProvider>
  </Provider>
);
